export const headerPaneNames = ['myDay', 'notifications'] as const;

export type HeaderPaneName = typeof headerPaneNames[number];
